var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#3D405B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.0056C15.4777 5.38205 14.8993 5.66997 14.2873 5.85827C13.9588 5.47235 13.5222 5.19882 13.0366 5.07467C12.5509 4.95052 12.0397 4.98175 11.572 5.16413C11.1044 5.34651 10.7028 5.67124 10.4216 6.09441C10.1405 6.51757 9.99329 7.01876 10 7.53017V8.08747C9.04144 8.11286 8.0916 7.89565 7.2351 7.45518C6.37859 7.01471 5.64199 6.36465 5.09091 5.5629C5.09091 5.5629 2.90909 10.5786 7.81818 12.8078C6.69483 13.5869 5.35663 13.9775 4 13.9224C8.90909 16.7089 14.9091 13.9224 14.9091 7.51345C14.9086 7.35822 14.894 7.20337 14.8655 7.05089C15.4221 6.48997 15.815 5.78176 16 5.0056Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.96e2b241.svg";
export { ForwardRef as ReactComponent };